import { UserAllScoresResult } from '../../dto/scores/cube/mapped/user-all-scores-results.dto';
import { AllScoresResponseDto } from '../../dto/scores/response/scores-response.dto';
import { calculateDeviation, formatDuration } from '../../helpers/duration.helper';
  
export const mapAllScoresResultsToScore = (
basicAllScores: UserAllScoresResult,
allTimeAverages: UserAllScoresResult,
weekdayAverages: UserAllScoresResult,
allTimeMaxes: UserAllScoresResult,
): AllScoresResponseDto => {
    const screenTimeDeviation = calculateDeviation(
        basicAllScores.screenTime,
        allTimeAverages.screenTime
    );
    const digitalIntensityDeviation = calculateDeviation(
        basicAllScores.digitalIntensity,
        allTimeAverages.digitalIntensity
    );
    const focusDeviation = calculateDeviation(
        basicAllScores.focus,
        allTimeAverages.focus
    );
    const workingHoursDeviation = calculateDeviation(
        basicAllScores.workingHours,
        allTimeAverages.workingHours
    );
    const timeInCallsDeviation = calculateDeviation(
        basicAllScores.timeInCalls,
        allTimeAverages.timeInCalls
    );
    return {
        hasData: true,
        screenTime: {
            value: formatDuration(basicAllScores.screenTime),
            unformattedValue: basicAllScores.screenTime,
            allTimeAverage: formatDuration(allTimeAverages.screenTime),
            allTimeAverageLine: Math.round(allTimeAverages.screenTime),
            max: formatDuration(allTimeMaxes.screenTime),
            weekdayAverage: formatDuration(weekdayAverages.screenTime),
            deviationFromAveragePercentage: screenTimeDeviation > 0
            ? `+${screenTimeDeviation}%`
            : `${screenTimeDeviation}%`,
        },
        digitalIntensity: {
            value: `${Math.round(basicAllScores.digitalIntensity).toString()}`,
            unformattedValue: basicAllScores.digitalIntensity,
            allTimeAverage: `${Math.round(allTimeAverages.digitalIntensity).toString()}`,
            allTimeAverageLine: Math.round(allTimeAverages.digitalIntensity),
            max: `${Math.round(allTimeMaxes.digitalIntensity).toString()}`,
            weekdayAverage: `${Math.round(weekdayAverages.digitalIntensity).toString()}`,
            deviationFromAveragePercentage: digitalIntensityDeviation > 0
            ? `+${digitalIntensityDeviation}%`
            : `${digitalIntensityDeviation}%`,
        },
        focus: {
            value: `${Math.round(basicAllScores.focus).toString()}`,
            unformattedValue: basicAllScores.focus,
            allTimeAverage: `${Math.round(allTimeAverages.focus).toString()}`,
            allTimeAverageLine: Math.round(allTimeAverages.focus),
            max: `${Math.round(allTimeMaxes.focus).toString()}`,
            weekdayAverage: `${Math.round(weekdayAverages.focus).toString()}`,
            deviationFromAveragePercentage: focusDeviation > 0
            ? `+${focusDeviation}%`
            : `${focusDeviation}%`,
        },
        workingHours: {
            value: formatDuration(basicAllScores.workingHours),
            unformattedValue: basicAllScores.workingHours,
            allTimeAverage: formatDuration(allTimeAverages.workingHours),
            allTimeAverageLine: Math.round(allTimeAverages.workingHours),
            max: formatDuration(allTimeMaxes.workingHours),
            weekdayAverage: formatDuration(weekdayAverages.workingHours),
            deviationFromAveragePercentage: workingHoursDeviation > 0
            ? `+${workingHoursDeviation}%`
            : `${workingHoursDeviation}%`,
        },
        timeInCalls: {
            value: formatDuration(basicAllScores.timeInCalls),
            unformattedValue: basicAllScores.timeInCalls,
            allTimeAverage: formatDuration(allTimeAverages.timeInCalls),
            allTimeAverageLine: Math.round(allTimeAverages.timeInCalls),
            max: formatDuration(allTimeMaxes.timeInCalls),
            weekdayAverage: formatDuration(weekdayAverages.timeInCalls),
            deviationFromAveragePercentage: timeInCallsDeviation > 0
            ? `+${timeInCallsDeviation}%`
            : `${timeInCallsDeviation}%`,
        }
    }
};
  